module.exports = __webpack_public_path__ + "img/11.b7e1ac59.png";